var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"calc(100% - 50px) !important","position":"relative"}},[_c('canvas',{attrs:{"id":_vm._uid}})])
}
var staticRenderFns = []

export { render, staticRenderFns }